import { combineReducers } from 'redux';
import produce from 'immer';
import { BillingAction, BillingActionType } from '../../actions/billingActions';

const loadingInvoices = (state = false, action: BillingAction) => {
  switch (action.type) {
    case BillingActionType.LIST_INVOICES:
      return true;
    case BillingActionType.LIST_INVOICES_ERROR:
    case BillingActionType.LIST_INVOICES_OK:
      return false;
    default:
      return state;
  }
};

type DownloadingState = { downloading: boolean; downloadingError: string };
interface DownloadingInvoiceFileState {
  [key: string]: DownloadingState;
}

const downloadingInvoiceFileById = (
  state = {} as DownloadingInvoiceFileState,
  action: BillingAction,
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case BillingActionType.LIST_INVOICES_OK: {
        action.data.forEach((invoice) => {
          draft[invoice.id] = {} as DownloadingState;
        });

        break;
      }
      case BillingActionType.GET_INVOICE_FILE:
        draft[action.id].downloading = true;
        break;
      case BillingActionType.GET_INVOICE_FILE_ERROR:
      case BillingActionType.GET_INVOICE_FILE_OK:
        draft[action.id].downloading = false;
        break;
      default:
        return state;
    }
  });

export default combineReducers({
  loadingInvoices,
  downloadingInvoiceFileById,
});
